// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.UmaGkW9kih0je2 {
  display: flex;
  flex-direction: row;
  align-items: center;
  white-space: nowrap;
  gap: var(--ds-space-100, 8px);
}
`, ""]);
// Exports
export var buttonContent = `UmaGkW9kih0je2`;
export default ___CSS_LOADER_EXPORT___;
